import React from "react";
import Panel from "../../components/panels/panel";
import { DeleteDialog } from "../../components";
import { routes } from "utilities/routing/generatedRoutes";
import Tag from "components/Tag/Tag";
import BrandIcon from "components/BrandIcon";
import { useDeleteBrandApi, useGetBrandsApi } from "brand/api";
import { ButtonPrimary } from "components/Atoms/Button";
import TwoColumnLayout from "layout/TwoColumnLayout";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import { PhosphorPencilAnchor } from "components/Atoms/PhosphorIconAnchor";
import { useLoaderData } from "react-router";

const BrandList = () => {
  const viewModel = useLoaderData<server.viewmodel.BrandListFrontModel>();

  const [deletingBrand, setDeletingBrand] = React.useState<server.dto.Brand>();
  const [isCreating, setIsCreating] = React.useState(false);

  const brandsApi = useGetBrandsApi();
  const deleteBrand = useDeleteBrandApi();

  const onDeleteClicked = (brand: server.dto.Brand) => {
    setDeletingBrand(brand);
  };

  const onDelete = async () => {
    const res = await deleteBrand.mutateAsync(deletingBrand.brandId);
    setDeletingBrand(undefined);
    if (res.data.hasErrors) {
      window.displayGenericModal(RESX.GeneralLabels.Delete, res.data.errors[0].message, "mini", "red");
    }
  };

  const onCreate = async () => {
    if (isCreating) return;
    setIsCreating(true);
    try {
      const res = await window.CoreApi.Brand.CreateBrand();
      window.location.href = routes.brand_Edit(res.data.data).absolute;
    } catch (err) {
      console.error(err);
    }
  }
  const canAddBrand = !brandsApi.isLoading && brandsApi.data?.pagination.total < serverReference.constants.brand.maxBrandsPerClient;

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <Panel
        panelClassName="s1_listview-panel"
        title={viewModel.pageTitle ?? RESX.Branding.resxBranding}
        button={<ButtonPrimary label={RESX.Buttons.btnNew} disabled={!canAddBrand} onClick={onCreate} />}
        hasData={brandsApi.isFetched && brandsApi.data?.data.length > 0}
        isLoading={brandsApi.isLoading}
        hasError={brandsApi.isError}
      >
        {brandsApi.isFetched && <div className="list-with-gaps card-layout">
          <div className="list-with-gaps-body">
            {brandsApi.data?.data.map(brand => {
              return <div key={brand.brandId}>
                <div style={{ padding: 2 }}>
                  <BrandIcon
                    iconUrl={brand.iconUrl}
                    size={50}
                    name={brand.name}
                  />
                </div>
                <div className="grow1">
                  <div>
                    <a href={routes.brand_Edit(brand.brandId).absolute} className="table-main-link">{brand.name}</a>
                  </div>
                  <div className="margin-top-small">
                    {brand.clientDefault && <Tag color={"blue"} label={RESX.GeneralLabels.resxDefault} />}
                  </div>
                </div>
                <PhosphorPencilAnchor
                  href={routes.brand_Edit(brand.brandId).absolute}
                  layout="in-square" />
                <PhosphorTrashButton
                  layout="in-square"
                  onClick={() => onDeleteClicked(brand)} />
              </div>
            })}
          </div>
        </div>}
        <DeleteDialog
          isOpen={deletingBrand != null}
          onDelete={onDelete}
          handleClose={() => setDeletingBrand(undefined)}
          message={RESX.GeneralWarnings.DeleteSure}
        />
      </Panel>
    </TwoColumnLayout.LeftColumn >
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout >;
};

export default BrandList;